import { assessmentDevelopmentLevel, isDevelopmentAssessment } from '../../shared/developmentLevels';

/** Input is already scoped to the selected class/date/assessment. No numeric coercion. */
export function summarizeDevelopmentAssessments(rows = [], roster = []) {
  const exams = new Map();
  const studentIds = new Set();
  rows.filter(isDevelopmentAssessment).forEach(row => {
    const id = String(row.exam_id ?? `date:${row.exam_date || ''}:${row.exam_title || ''}`);
    if (!exams.has(id)) exams.set(id, {
      id, title: row.exam_title || 'Değerlendirme', date: row.exam_date || '',
      subject: row.lesson_name || 'Ders belirtilmedi', lessonId: row.lesson_id,
      byStudent: new Map(),
    });
    const exam = exams.get(id);
    const studentId = String(row.student_id ?? '');
    if (!studentId || exam.byStudent.has(studentId)) return;
    const level = assessmentDevelopmentLevel(row);
    const status = row.result_status === 'absent' ? 'absent' : level ? 'completed' : 'pending';
    exam.byStudent.set(studentId, {
      id: studentId, name: row.student_name || `Öğrenci ${studentId}`,
      developmentLevel: level, status,
    });
    if (level) studentIds.add(studentId);
  });
  const items = [...exams.values()].map(({ byStudent, ...exam }) => {
    roster.forEach(student => {
      const id = String(student.student_id ?? student.id ?? '');
      const name = student.student_name || student.full_name ||
        [student.name, student.surname].filter(Boolean).join(' ') || `Öğrenci ${id}`;
      if (id && !byStudent.has(id)) byStudent.set(id, { id, name, developmentLevel: null, status: 'pending' });
      else if (id && byStudent.get(id).name.startsWith('Öğrenci ')) byStudent.get(id).name = name;
    });
    const students = [...byStudent.values()].sort((a, b) => a.name.localeCompare(b.name, 'tr-TR'));
    const distribution = { level_1: 0, level_2: 0, level_3: 0, level_4: 0 };
    students.forEach(student => { if (student.developmentLevel) distribution[student.developmentLevel] += 1; });
    return {
      ...exam, students, distribution,
      evaluated: students.filter(s => s.status === 'completed').length,
      absent: students.filter(s => s.status === 'absent').length,
      pending: students.filter(s => s.status === 'pending').length,
    };
  }).sort((a, b) => b.date.localeCompare(a.date) || a.title.localeCompare(b.title, 'tr-TR'));
  return { exams: items, resultCount: items.reduce((sum, exam) => sum + exam.evaluated, 0), studentCount: studentIds.size };
}
